import type { FC } from "react";

import type { SecondaryFooterProps } from "~/features/secondary-footer/SecondaryFooter";
import { CmsHtml } from "~/shared/ui/CmsHtml";

const markdownLinkStyles = "w-full [&_a]:underline [&_a]:underline-offset-2";

export const FooterDescription: FC<SecondaryFooterProps> = ({ data }) => {
  const mobileDescription = data?.translations?.[0]?.mobile_description ?? "";
  const tabletDescription =
    data?.translations?.[0]?.tablet_description ?? mobileDescription;
  const desktopDescription =
    data?.translations?.[0]?.desktop_description ?? tabletDescription;
  return (
    <div className={markdownLinkStyles}>
      {data?.translations?.[0]?.licenses && (
        <CmsHtml>{data?.translations?.[0]?.licenses}</CmsHtml>
      )}
      <div className="block md:hidden">
        <CmsHtml>{mobileDescription}</CmsHtml>
      </div>
      <div className="max-md:hidden md:block lg:hidden">
        <CmsHtml>{tabletDescription}</CmsHtml>
      </div>
      <div className="hidden lg:block">
        <CmsHtml>{desktopDescription}</CmsHtml>
      </div>
    </div>
  );
};
